// Generated by project/scripts/export-admin-feature-permissions.php. Do not edit.
export const currentPermissionCodes = [
  'content',
  'customPage',
  'customPageList',
  'page:list',
  'page:create',
  'page:edit',
  'page:delete',
  'page:publish',
  'page:copy',
  'page:category-manage',
  'page:configure',
  'page:analytics',
  'customForm',
  'customFormList',
  'form:list',
  'form:create',
  'form:edit',
  'form:publish',
  'form:copy',
  'form:delete',
  'form:add-data',
  'form:preview',
  'form:submissions',
  'form:export',
  'form:submitters',
  'form:report',
  'traffic',
  'trafficLandingPage',
  'trafficLandingPageCreate',
  'trafficLandingPageEdit',
  'trafficLandingPageDelete',
  'trafficLandingPageLink',
  'trafficConversionConfig',
  'trafficConversionConfigCreate',
  'trafficConversionConfigEdit',
  'trafficConversionConfigTest',
  'trafficConversionLog',
  'trafficConversionLogRetry',
  'trafficWorkWxContact',
  'trafficWorkWxContactCreate',
  'trafficWorkWxContactEdit',
  'trafficWorkWxContactDelete',
  'trafficWorkWxContactConfigureCorp',
  'trafficWorkWxContactBindMember',
  'trafficWorkWxContactGenerate',
  'trafficManagement',
  'channelConversion',
  'channelRules',
  'channelRulesCreate',
  'channelRulesEdit',
  'channelRulesDelete',
  'channelRulesRebuild',
  'trafficMaterialManagement',
  'trafficAccountBinding',
  'trafficAccountBindingEdit',
  'trafficTrack',
  'trafficMaterialTrace',
  'trafficDashboard',
  'trafficDashboardMaterials',
  'trafficDashboardStaff',
  'trafficDashboardTargetEdit',
  'trafficDashboardRosterEdit',
  'trafficDashboardRosterSync',
  'frontend',
  'frontendExperienceCamp',
  'frontendExperienceCampList',
  'frontendExperienceCampRepairBindings',
  'frontendAutoOps',
  'frontendHostedWx',
  'frontendHostedWxList',
  'frontendHostedWxLogin',
  'frontendHostedWxEdit',
  'frontendHostedWxToggle',
  'frontendHostedWxDelete',
  'frontendHostedWxRefresh',
  'frontendHostedWxLogs',
  'frontendJuziAccount',
  'frontendJuziAccountList',
  'frontendJuziAccountSync',
  'frontendSopTemplate',
  'frontendSopTemplateList',
  'frontendSopTemplateCreate',
  'frontendSopTemplateEdit',
  'frontendSopTemplateEnable',
  'frontendSopTemplateDisable',
  'frontendSopTemplateCopy',
  'frontendSopTemplateDelete',
  'frontendSopTemplateImport',
  'frontendTask',
  'frontendTaskList',
  'frontendTaskCreate',
  'frontendTaskDelete',
  'frontendTaskPause',
  'frontendTaskResume',
  'frontendTaskTerminate',
  'frontendTaskRetryNow',
  'frontendTaskConfirm',
  'frontendTaskResend',
  'frontendTaskTrace',
  'frontendHostedWxZhonghui',
  'backend',
  'meetingSales',
  'meetingSalesActivity',
  'meetingSalesActivityList',
  'meetingSalesActivityEdit',
  'meetingSalesActivityReview',
  'meetingSalesActivityDelete',
  'meetingSalesActivityShare',
  'meetingSalesActivityCheckinCode',
  'meetingSalesActivityStopRegistration',
  'meetingSalesActivityResumeRegistration',
  'meetingSalesActivityDetail',
  'meetingSalesRegistration',
  'meetingSalesRegistrationList',
  'meetingSalesRegistrationEdit',
  'meetingSalesRegistrationReview',
  'meetingSalesRegistrationImport',
  'meetingSalesRegistrationExport',
  'meetingSalesGroup',
  'meetingSalesMembers',
  'meetingSalesMembersList',
  'meetingSalesMembersEdit',
  'meetingSalesMembersExport',
  'meetingSalesGroupList',
  'meetingSalesGroupEdit',
  'meetingSalesGroupDelete',
  'meetingSalesGroupAuto',
  'meetingSalesGroupImport',
  'meetingSalesGroupLeaders',
  'meetingSalesGroupExport',
  'meetingSalesHotel',
  'meetingSalesHotelList',
  'meetingSalesHotelEdit',
  'meetingSalesHotelDelete',
  'meetingSalesHotelShare',
  'meetingSalesHotelDetail',
  'meetingSalesRoom',
  'meetingSalesRoomList',
  'meetingSalesRoomEdit',
  'meetingSalesRoomDelete',
  'meetingSalesBooking',
  'meetingSalesBookingList',
  'meetingSalesBookingEdit',
  'meetingSalesBookingReview',
  'meetingSalesBookingImport',
  'meetingSalesBookingExport',
  'meetingSalesRooming',
  'meetingSalesRoomingList',
  'meetingSalesRoomingEdit',
  'meetingSalesRoomingAuto',
  'meetingSalesRoomingImport',
  'meetingSalesRoomingExport',
  'backendLevel2Users',
  'backendLevel3Users',
  'backendLevel4Users',
  'backendOrder',
  'backendManualPayOrder',
  'backendManualPayOrderCreate',
  'backendManualPayOrderEdit',
  'backendManualPayOrderAudit',
  'backendPayOrder',
  'backendSetting',
  'backendCamp',
  'backendMember',
  'backendMemberUser',
  'bill',
  'billSaleOrder',
  'billSaleManualPayOrder',
  'billSaleManualPayOrderEdit',
  'billSaleManualPayOrderSubmitAudit',
  'billSaleManualPayOrderAudit',
  'billSalePayOrder',
  'billBackendOrder',
  'billBackendManualPayOrder',
  'billBackendManualPayOrderCreate',
  'billBackendManualPayOrderEdit',
  'billBackendManualPayOrderAudit',
  'billBackendPayOrder',
  'billStatement',
  'billBankStatement',
  'billBankStatementImport',
  'billBankStatementExport',
  'billTangLangStatement',
  'billTangLangStatementImport',
  'billTangLangStatementExport',
  'billStatementOrder',
  'billLandingPageOrder',
  'billLandingPageOrderRefund',
  'billWorkWxOrder',
  'data',
  'dataCustomerManagement',
  'dataCustomerList',
  'dataCustomerBehavior',
  'dataCustomerBehaviorUser',
  'dataCustomerBehaviorRecord',
  'dataCustomerBehaviorDefinition',
  'dataCustomerListCreate',
  'dataCustomerListEdit',
  'dataCustomerField',
  'dataCustomerFieldCreate',
  'dataCustomerFieldEdit',
  'dataCustomerFieldReorder',
  'dataCustomerTag',
  'dataCustomerTagCreate',
  'dataCustomerTagCreateWorkWx',
  'dataCustomerTagEdit',
  'dataCustomerTagAssign',
  'dataCustomerTagSyncWorkWx',
  'dataCustomerStage',
  'dataCustomerStageCreate',
  'dataCustomerStageEdit',
  'dataCustomerStageDelete',
  'dataCustomerStageToggle',
  'dataCustomerStageReorder',
  'dataCustomerSource',
  'dataCustomerSourceCreate',
  'dataCustomerSourceEdit',
  'dataCustomerSourceDelete',
  'dataCustomerSourceToggle',
  'dataCustomerSourceReorder',
  'dataCustomerChannel',
  'dataCustomerChannelCreate',
  'dataCustomerChannelEdit',
  'dataCustomerChannelDelete',
  'dataCustomerChannelToggle',
  'dataCustomerChannelReorder',
  'dataAutomationWorkflow',
  'dataWorkflow',
  'dataWorkflowCreate',
  'dataWorkflowEdit',
  'dataWorkflowCopy',
  'dataWorkflowDelete',
  'dataWorkflowPublish',
  'dataWorkflowExecute',
  'dataWorkflowToggle',
  'dataWorkflowLogs',
  'dataTrack',
  'dataTrackRepair',
  'dataTrackBackfill',
  'thirdPlatform',
  'thirdPlatformWechat',
  'systemWechatPublicAccounts',
  'systemWechatPublicAccountsCreate',
  'systemWechatPublicAccountsEdit',
  'systemWechatPublicAccountsDelete',
  'systemWechatPublicAccountsToggle',
  'systemWechatApps',
  'systemWechatAppsCreate',
  'systemWechatAppsEdit',
  'systemWechatAppsDelete',
  'systemWechatAppsToggle',
  'thirdPlatformWorkWx',
  'thirdPlatformWorkWxCorp',
  'thirdPlatformWorkWxCorpConfigureContact',
  'thirdPlatformWorkWxCorpConfigureCallback',
  'systemWorkWxApps',
  'systemWorkWxAppsSyncMembers',
  'systemWorkWxAppsSyncContacts',
  'systemWorkWxAppsSyncTags',
  'systemWorkWxAppsSyncGroupChats',
  'thirdPlatformWorkWxUser',
  'thirdPlatformWorkWxUserBindEmployee',
  'thirdPlatformWorkWxUserViewCustomers',
  'thirdPlatformWorkWxUserViewGroupChats',
  'thirdPlatformWorkWxUserSyncCustomers',
  'thirdPlatformWorkWxUserSyncGroupChats',
  'thirdPlatformWorkWxExternalUser',
  'thirdPlatformWorkWxGroupChat',
  'thirdPlatformWorkWxFollowUser',
  'thirdPlatformWorkWxExternalPayBill',
  'thirdPlatformWorkWxExternalPayBillExport',
  'workWxNativePayment',
  'workWxNativePaymentConfigure',
  'workWxNativePaymentCreate',
  'thirdPlatformWorkWxExternalRefundOrder',
  'thirdPlatformWorkWxExternalRefundOrderExport',
  'thirdPlatformWorkWxFundFlow',
  'thirdPlatformWorkWxFundFlowExport',
  'thirdPlatformFeiShu',
  'systemFeiShuApps',
  'systemFeiShuAppsCreate',
  'systemFeiShuAppsEdit',
  'systemFeiShuAppsSyncDepartments',
  'systemFeiShuAppsSyncMembers',
  'thirdPlatformFeiShuTrafficOrder',
  'thirdPlatformFeiShuSaleOrder',
  'thirdPlatformFeiShuSaleOrderExport',
  'thirdPlatformFeiShuBackendSaleOrder',
  'thirdPlatformFeiShuBackendSaleOrderExport',
  'thirdPlatformFeiShuRpaOrder',
  'thirdPlatformFeiShuTableRecord',
  'thirdPlatformTencentAd',
  'thirdPlatformTencentAdAccess',
  'thirdPlatformTencentAdAccessAppCreate',
  'thirdPlatformTencentAdAccessAppEdit',
  'thirdPlatformTencentAdAccessConnectionCreate',
  'thirdPlatformTencentAdAccessConnectionEdit',
  'thirdPlatformTencentAdAccessRefresh',
  'thirdPlatformTencentAdReports',
  'thirdPlatformMapService',
  'thirdPlatformMapSettings',
  'thirdPlatformMapServiceEdit',
  'thirdPlatformMapServiceLocate',
  'thirdPlatformMapServiceLog',
  'thirdPlatformMapTencent',
  'thirdPlatformMapTencentEdit',
  'thirdPlatformMapAmap',
  'thirdPlatformMapAmapEdit',
  'thirdPlatformXingCheng',
  'thirdPlatformXingChengTrafficOrder',
  'thirdPlatformXingChengAccount',
  'thirdPlatformXingChengAccountCreate',
  'thirdPlatformXingChengAccountEdit',
  'thirdPlatformXingChengAccountLogin',
  'thirdPlatformXingChengAccountToggle',
  'thirdPlatformTangLang',
  'thirdPlatformTangLangScheduledTask',
  'thirdPlatformTangLangAccount',
  'thirdPlatformTangLangAccountLogin',
  'thirdPlatformTangLangAccountTest',
  'thirdPlatformTangLangAccountTestMobile',
  'thirdPlatformTangLangAccountTestCustomerRecent',
  'thirdPlatformTangLangAccountTestInterface',
  'thirdPlatformTangLangAccountSyncSetting',
  'thirdPlatformTangLangProduct',
  'thirdPlatformTangLangTrafficOrder',
  'thirdPlatformTangLangCustomer',
  'thirdPlatformTangLangCustomerSyncRecent',
  'thirdPlatformTangLangCustomerEnrich',
  'thirdPlatformTangLangRefundOrder',
  'thirdPlatformTangLangRefundOrderExport',
  'thirdPlatformTangLangPayOrder',
  'thirdPlatformTangLangPayOrderExport',
  'thirdPlatformTangLangCampLearning',
  'thirdPlatformWechatPay',
  'thirdPlatformWechatPayMerchant',
  'thirdPlatformWechatPayMerchantCreate',
  'thirdPlatformWechatPayMerchantEdit',
  'thirdPlatformWechatPayMerchantDelete',
  'thirdPlatformWechatPayMerchantSync',
  'thirdPlatformWechatPayFundFlow',
  'thirdPlatformWechatPayFundFlowExport',
  'thirdPlatformWechatPayTradeBill',
  'thirdPlatformWechatPayTradeBillExport',
  'thirdPlatformZhuGe',
  'thirdPlatformZhuGeOrder',
  'thirdPlatformZhuGeAuthorReportDay',
  'thirdPlatformZhuGeAuthorVideoPlanDay',
  'thirdPlatformZhuGeReportDay',
  'thirdPlatformWxShop',
  'thirdPlatformWxShopFundsFlow',
  'thirdPlatformWxShopFundsFlowExport',
  'thirdPlatformWxShopOrderFlow',
  'thirdPlatformWxShopOrderFlowExport',
  'thirdPlatformDouGong',
  'thirdPlatformDouGongTradeBill',
  'thirdPlatformBank',
  'thirdPlatformBankUnionPayFlow',
  'thirdPlatformBankUnionPayFlowExport',
  'thirdPlatformBankStatement',
  'thirdPlatformBankStatementImport',
  'thirdPlatformBankStatementExport',
  'thirdPlatformBaidu',
  'thirdPlatformBaiduApp',
  'thirdPlatformBaiduAppCreate',
  'thirdPlatformBaiduAppEdit',
  'thirdPlatformBaiduAppAuthorize',
  'thirdPlatformBaiduAuthorization',
  'thirdPlatformBaiduAuthorizationRefresh',
  'thirdPlatformBaiduAuthorizationSync',
  'thirdPlatformBaiduAccountReport',
  'thirdPlatformBaiduAccountReportSync',
  'thirdPlatformBaiduVideoReport',
  'thirdPlatformBaiduVideoReportSync',
  'thirdPlatformXiaohongshu',
  'thirdPlatformXiaohongshuApp',
  'thirdPlatformXiaohongshuAppCreate',
  'thirdPlatformXiaohongshuAppEdit',
  'thirdPlatformXiaohongshuAppAuthorize',
  'thirdPlatformXiaohongshuAuthorization',
  'thirdPlatformXiaohongshuAccount',
  'thirdPlatformXiaohongshuAccountSync',
  'thirdPlatformXiaohongshuNote',
  'thirdPlatformXiaohongshuNoteSync',
  'thirdPlatformXiaohongshuAccountReport',
  'thirdPlatformXiaohongshuAccountReportSync',
  'thirdPlatformXiaohongshuCampaignReport',
  'thirdPlatformXiaohongshuCampaignReportSync',
  'thirdPlatformXiaohongshuCreativeReport',
  'thirdPlatformXiaohongshuCreativeReportSync',
  'thirdPlatformQianchuan',
  'thirdPlatformQianchuanApp',
  'thirdPlatformQianchuanAppCreate',
  'thirdPlatformQianchuanAppEdit',
  'thirdPlatformQianchuanAppAuthorize',
  'thirdPlatformQianchuanAuthorization',
  'thirdPlatformQianchuanAuthorizationRefresh',
  'thirdPlatformQianchuanAuthorizedAccount',
  'thirdPlatformQianchuanAuthorizedAccountSync',
  'thirdPlatformQianchuanAccount',
  'thirdPlatformQianchuanAccountSync',
  'thirdPlatformQianchuanAccountReport',
  'thirdPlatformQianchuanAccountReportSync',
  'thirdPlatformQianchuanReportSummary',
  'thirdPlatformQianchuanMaterialReport',
  'thirdPlatformQianchuanMaterialReportSync',
  'thirdPlatformIeh5',
  'thirdPlatformIeh5Account',
  'thirdPlatformIeh5AccountToggle',
  'thirdPlatformIeh5AccountLogin',
  'thirdPlatformIeh5AdAccount',
  'thirdPlatformIeh5AdAccountSync',
  'thirdPlatformIeh5OrderManagement',
  'thirdPlatformIeh5IssuedData',
  'thirdPlatformIeh5OrderRecompute',
  'thirdPlatformIeh5MaterialAttribution',
  'thirdPlatformIeh5OperationReport',
  'thirdPlatformIeh5ShipinhaoReport',
  'thirdPlatformIeh5ShipinhaoReportSync',
  'thirdPlatformIeh5FinanceReport',
  'thirdPlatformIeh5PlacementData',
  'thirdPlatformIeh5MaterialReport',
  'system',
  'projectManagement',
  'projectList',
  'projectListCreate',
  'projectListEdit',
  'projectListDelete',
  'systemCourse',
  'systemCourseCreate',
  'systemCourseEdit',
  'systemCourseDelete',
  'systemCoursePeriod',
  'systemCoursePeriodCreate',
  'systemCoursePeriodEdit',
  'systemCoursePeriodLessonEdit',
  'systemCoursePeriodLessonDelete',
  'systemCoursePeriodSyncLessons',
  'systemCoursePeriodSyncStudents',
  'systemProduct',
  'systemProductCreate',
  'systemProductEdit',
  'systemProductDelete',
  'systemProductBindCourses',
  'systemChannel',
  'systemChannelCreate',
  'systemChannelEdit',
  'systemChannelDelete',
  'systemChannelToggle',
  'systemChannelChannelCreate',
  'systemChannelChannelEdit',
  'systemChannelChannelToggle',
  'systemChannelChannelDelete',
  'systemTeam',
  'systemDepartment',
  'systemDepartmentCreate',
  'systemDepartmentEdit',
  'systemDepartmentMove',
  'systemDepartmentToggle',
  'systemDepartmentDelete',
  'systemDepartmentMembers',
  'systemDepartmentAdmins',
  'systemDepartmentResetPassword',
  'systemRole',
  'systemRoleCreate',
  'systemRoleEdit',
  'systemRoleMembers',
  'systemPermission',
  'systemPermissionCreate',
  'systemPermissionEdit',
  'systemDataPermissionRoute',
  'systemDataPermission',
  'systemDataPermissionCreate',
  'systemDataPermissionEdit',
  'systemDataPermissionDelete',
  'systemDataPermissionRouteEdit',
  'systemDataPermissionRouteSync',
  'systemEmployee',
  'systemDataProtection',
  'systemDataProtectionEdit',
  'systemFeiShuTableConfigMapping',
  'systemFeiShuTableConfigMappingCreate',
  'systemFeiShuTableConfigMappingEdit',
  'systemFeiShuTableConfigMappingDelete',
  'systemFeiShuTableConfigMappingSync',
  'materialLibrary',
  'material:list',
  'material:create',
  'material:edit',
  'material:delete',
  'material:publish',
  'material:configure',
  'material:analytics',
  'shortLink',
  'short-link:list',
  'short-link:create',
  'short-link:edit',
  'systemMcp',
  'systemOperationLog',
  'common',
  'commonUser',
  'sale',
  'saleClass',
  'saleClassUser',
  'saleOrder',
  'dataOrderCenter',
  'dataOrderCenterRepair',
  'saleManualPayOrder',
  'saleManualPayOrderEdit',
  'saleManualPayOrderSubmitAudit',
  'saleManualPayOrderAudit',
  'salePayOrder',
  'saleSetting',
  'saleCamp',
  'saleMarketIntentQuestionnaire',
  'saleMarketIntentQuestionnaireCreate',
  'saleMarketIntentQuestionnaireEdit',
  'saleMarketIntentQuestionnairePublish',
  'saleMarketIntentQuestionnaireDelete',
  'saleMarketIntentRespondent',
  'saleMarketIntentRespondentCreate',
  'saleMarketIntentRespondentEdit',
  'saleMarketIntentRespondentDelete',
  'saleMarketIntentTask',
  'saleMarketIntentTaskCreate',
  'saleMarketIntentTaskEdit',
  'saleMarketIntentTaskStart',
  'saleMarketIntentTaskClose',
  'saleMarketIntentResult',
  'saleMarketIntentResultExport',
] as const;
export default {
  trafficDashboard: [
    'trafficDashboardMaterials',
    'trafficDashboardStaff',
    'trafficDashboardTargetEdit',
    'trafficDashboardRosterEdit',
    'trafficDashboardRosterSync',
  ],
  dataCustomerList: ['dataCustomerListCreate', 'dataCustomerListEdit'],
  dataCustomerField: [
    'dataCustomerFieldCreate',
    'dataCustomerFieldEdit',
    'dataCustomerFieldReorder',
  ],
  dataCustomerStage: [
    'dataCustomerStageCreate',
    'dataCustomerStageEdit',
    'dataCustomerStageDelete',
    'dataCustomerStageToggle',
    'dataCustomerStageReorder',
  ],
  dataCustomerSource: [
    'dataCustomerSourceCreate',
    'dataCustomerSourceEdit',
    'dataCustomerSourceDelete',
    'dataCustomerSourceToggle',
    'dataCustomerSourceReorder',
  ],
  dataCustomerChannel: [
    'dataCustomerChannelCreate',
    'dataCustomerChannelEdit',
    'dataCustomerChannelDelete',
    'dataCustomerChannelToggle',
    'dataCustomerChannelReorder',
  ],
  dataWorkflow: [
    'dataWorkflowCreate',
    'dataWorkflowEdit',
    'dataWorkflowCopy',
    'dataWorkflowDelete',
    'dataWorkflowPublish',
    'dataWorkflowExecute',
    'dataWorkflowToggle',
    'dataWorkflowLogs',
  ],
  projectList: ['projectListCreate', 'projectListEdit', 'projectListDelete'],
  systemCourse: [
    'systemCourseCreate',
    'systemCourseEdit',
    'systemCourseDelete',
  ],
  systemCoursePeriod: [
    'systemCoursePeriodCreate',
    'systemCoursePeriodEdit',
    'systemCoursePeriodLessonEdit',
    'systemCoursePeriodLessonDelete',
    'systemCoursePeriodSyncLessons',
    'systemCoursePeriodSyncStudents',
  ],
  systemProduct: [
    'systemProductCreate',
    'systemProductEdit',
    'systemProductDelete',
    'systemProductBindCourses',
  ],
  systemChannel: [
    'systemChannelCreate',
    'systemChannelEdit',
    'systemChannelDelete',
    'systemChannelToggle',
    'systemChannelChannelCreate',
    'systemChannelChannelEdit',
    'systemChannelChannelToggle',
    'systemChannelChannelDelete',
  ],
  systemFeiShuTableConfigMapping: [
    'systemFeiShuTableConfigMappingCreate',
    'systemFeiShuTableConfigMappingEdit',
    'systemFeiShuTableConfigMappingDelete',
    'systemFeiShuTableConfigMappingSync',
  ],
  channelRules: [
    'channelRulesCreate',
    'channelRulesEdit',
    'channelRulesDelete',
    'channelRulesRebuild',
  ],
  trafficLandingPage: [
    'trafficLandingPageCreate',
    'trafficLandingPageEdit',
    'trafficLandingPageDelete',
    'trafficLandingPageLink',
  ],
  thirdPlatformMapService: [
    'thirdPlatformMapServiceEdit',
    'thirdPlatformMapServiceLocate',
    'thirdPlatformMapServiceLog',
  ],
  trafficAccountBinding: ['trafficAccountBindingEdit'],
  thirdPlatformTencentAdAccess: [
    'thirdPlatformTencentAdAccessAppCreate',
    'thirdPlatformTencentAdAccessAppEdit',
    'thirdPlatformTencentAdAccessConnectionCreate',
    'thirdPlatformTencentAdAccessConnectionEdit',
    'thirdPlatformTencentAdAccessRefresh',
  ],
  trafficWorkWxContact: [
    'trafficWorkWxContactCreate',
    'trafficWorkWxContactEdit',
    'trafficWorkWxContactDelete',
    'trafficWorkWxContactConfigureCorp',
    'trafficWorkWxContactBindMember',
    'trafficWorkWxContactGenerate',
  ],
  billBankStatement: ['billBankStatementImport', 'billBankStatementExport'],
  billTangLangStatement: [
    'billTangLangStatementImport',
    'billTangLangStatementExport',
  ],
  thirdPlatformBankStatement: [
    'thirdPlatformBankStatementImport',
    'thirdPlatformBankStatementExport',
  ],
  thirdPlatformBankUnionPayFlow: ['thirdPlatformBankUnionPayFlowExport'],
  thirdPlatformWechatPayMerchant: [
    'thirdPlatformWechatPayMerchantCreate',
    'thirdPlatformWechatPayMerchantEdit',
    'thirdPlatformWechatPayMerchantDelete',
    'thirdPlatformWechatPayMerchantSync',
  ],
  thirdPlatformWechatPayFundFlow: ['thirdPlatformWechatPayFundFlowExport'],
  thirdPlatformWechatPayTradeBill: ['thirdPlatformWechatPayTradeBillExport'],
  thirdPlatformBaiduApp: [
    'thirdPlatformBaiduAppCreate',
    'thirdPlatformBaiduAppEdit',
    'thirdPlatformBaiduAppAuthorize',
  ],
  thirdPlatformBaiduAuthorization: [
    'thirdPlatformBaiduAuthorizationRefresh',
    'thirdPlatformBaiduAuthorizationSync',
  ],
  thirdPlatformBaiduAccountReport: ['thirdPlatformBaiduAccountReportSync'],
  thirdPlatformXiaohongshuApp: [
    'thirdPlatformXiaohongshuAppCreate',
    'thirdPlatformXiaohongshuAppEdit',
    'thirdPlatformXiaohongshuAppAuthorize',
  ],
  thirdPlatformXiaohongshuAuthorization: [],
  thirdPlatformXiaohongshuAccount: ['thirdPlatformXiaohongshuAccountSync'],
  thirdPlatformXiaohongshuAccountReport: [
    'thirdPlatformXiaohongshuAccountReportSync',
  ],
  thirdPlatformQianchuanApp: [
    'thirdPlatformQianchuanAppCreate',
    'thirdPlatformQianchuanAppEdit',
    'thirdPlatformQianchuanAppAuthorize',
  ],
  thirdPlatformQianchuanAuthorization: [
    'thirdPlatformQianchuanAuthorizationRefresh',
  ],
  thirdPlatformQianchuanAuthorizedAccount: [
    'thirdPlatformQianchuanAuthorizedAccountSync',
  ],
  thirdPlatformQianchuanAccount: ['thirdPlatformQianchuanAccountSync'],
  thirdPlatformQianchuanAccountReport: [
    'thirdPlatformQianchuanAccountReportSync',
  ],
  thirdPlatformIeh5Account: [
    'thirdPlatformIeh5AccountToggle',
    'thirdPlatformIeh5AccountLogin',
  ],
  thirdPlatformIeh5AdAccount: ['thirdPlatformIeh5AdAccountSync'],
  thirdPlatformIeh5ShipinhaoReport: ['thirdPlatformIeh5ShipinhaoReportSync'],
  thirdPlatformXingChengAccount: [
    'thirdPlatformXingChengAccountCreate',
    'thirdPlatformXingChengAccountEdit',
    'thirdPlatformXingChengAccountLogin',
    'thirdPlatformXingChengAccountToggle',
  ],
  systemPermission: ['systemPermissionCreate', 'systemPermissionEdit'],
  systemDataPermission: [
    'systemDataPermissionCreate',
    'systemDataPermissionEdit',
    'systemDataPermissionDelete',
  ],
  systemDataPermissionRoute: [
    'systemDataPermissionRouteEdit',
    'systemDataPermissionRouteSync',
    'systemDataPermission',
    'systemDataPermissionCreate',
    'systemDataPermissionEdit',
    'systemDataPermissionDelete',
  ],
  systemDataProtection: ['systemDataProtectionEdit'],
  saleMarketIntentQuestionnaire: [
    'saleMarketIntentQuestionnaireCreate',
    'saleMarketIntentQuestionnaireEdit',
    'saleMarketIntentQuestionnairePublish',
    'saleMarketIntentQuestionnaireDelete',
  ],
  saleMarketIntentRespondent: [
    'saleMarketIntentRespondentCreate',
    'saleMarketIntentRespondentEdit',
    'saleMarketIntentRespondentDelete',
  ],
  saleMarketIntentTask: [
    'saleMarketIntentTaskCreate',
    'saleMarketIntentTaskEdit',
    'saleMarketIntentTaskStart',
    'saleMarketIntentTaskClose',
    'saleMarketIntentResult',
    'saleMarketIntentResultExport',
  ],
  saleMarketIntentResult: ['saleMarketIntentResultExport'],
  trafficConversionConfig: [
    'trafficConversionConfigCreate',
    'trafficConversionConfigEdit',
    'trafficConversionConfigTest',
  ],
  trafficConversionLog: ['trafficConversionLogRetry'],
  systemDepartment: [
    'systemRoleMembers',
    'systemDepartmentCreate',
    'systemDepartmentEdit',
    'systemDepartmentMove',
    'systemDepartmentToggle',
    'systemDepartmentDelete',
    'systemDepartmentMembers',
    'systemDepartmentAdmins',
    'systemDepartmentResetPassword',
  ],
  dataOrderCenter: ['dataOrderCenterRepair'],
  dataTrack: ['dataTrackRepair', 'dataTrackBackfill', 'trafficTrack'],
  saleManualPayOrder: [
    'saleManualPayOrderEdit',
    'saleManualPayOrderSubmitAudit',
    'saleManualPayOrderAudit',
  ],
  backendManualPayOrder: [
    'backendManualPayOrderCreate',
    'backendManualPayOrderEdit',
    'backendManualPayOrderAudit',
  ],
  thirdPlatformWorkWxUser: [
    'thirdPlatformWorkWxUserBindEmployee',
    'thirdPlatformWorkWxUserViewCustomers',
    'thirdPlatformWorkWxUserViewGroupChats',
    'thirdPlatformWorkWxUserSyncCustomers',
    'thirdPlatformWorkWxUserSyncGroupChats',
  ],
  thirdPlatformWorkWxCorp: [
    'thirdPlatformWorkWxCorpConfigureContact',
    'thirdPlatformWorkWxCorpConfigureCallback',
  ],
  workWxNativePayment: ['workWxNativePaymentConfigure'],
  thirdPlatformTangLangPayOrder: ['thirdPlatformTangLangPayOrderExport'],
  thirdPlatformTangLangRefundOrder: ['thirdPlatformTangLangRefundOrderExport'],
  thirdPlatformFeiShuSaleOrder: ['thirdPlatformFeiShuSaleOrderExport'],
  thirdPlatformFeiShuBackendSaleOrder: [
    'thirdPlatformFeiShuBackendSaleOrderExport',
  ],
  thirdPlatformWorkWxExternalPayBill: [
    'thirdPlatformWorkWxExternalPayBillExport',
  ],
  thirdPlatformWorkWxExternalRefundOrder: [
    'thirdPlatformWorkWxExternalRefundOrderExport',
  ],
  thirdPlatformWorkWxFundFlow: ['thirdPlatformWorkWxFundFlowExport'],
  thirdPlatformWxShopFundsFlow: ['thirdPlatformWxShopFundsFlowExport'],
  thirdPlatformWxShopOrderFlow: ['thirdPlatformWxShopOrderFlowExport'],
  billSaleManualPayOrder: [
    'billSaleManualPayOrderEdit',
    'billSaleManualPayOrderSubmitAudit',
    'billSaleManualPayOrderAudit',
  ],
  billBackendManualPayOrder: [
    'billBackendManualPayOrderCreate',
    'billBackendManualPayOrderEdit',
    'billBackendManualPayOrderAudit',
  ],
  channelConversion: [],
  backendLevel2Users: [],
  backendLevel3Users: [],
  backendLevel4Users: [],
  thirdPlatformTangLangProduct: [],
  thirdPlatformBaiduVideoReport: ['thirdPlatformBaiduVideoReportSync'],
  thirdPlatformXiaohongshuNote: ['thirdPlatformXiaohongshuNoteSync'],
  thirdPlatformXiaohongshuCampaignReport: [
    'thirdPlatformXiaohongshuCampaignReportSync',
  ],
  thirdPlatformXiaohongshuCreativeReport: [
    'thirdPlatformXiaohongshuCreativeReportSync',
  ],
  thirdPlatformQianchuanReportSummary: [],
  thirdPlatformQianchuanMaterialReport: [
    'thirdPlatformQianchuanMaterialReportSync',
  ],
  thirdPlatformMapSettings: [
    'thirdPlatformMapServiceEdit',
    'thirdPlatformMapServiceLocate',
    'thirdPlatformMapServiceLog',
  ],
  thirdPlatformMapTencent: ['thirdPlatformMapTencentEdit'],
  thirdPlatformMapAmap: ['thirdPlatformMapAmapEdit'],
} satisfies Record<string, string[]>;
export const adminMenuRoutes: Record<
  string,
  { code: string; name: string; access: string }
> = {
  '/content': {
    code: 'content',
    name: '内容管理',
    access: 'content',
  },
  '/content/page': {
    code: 'customPage',
    name: '微页面管理',
    access: 'customPage',
  },
  '/content/page/list': {
    code: 'customPageList',
    name: '微页面列表',
    access: 'page:list',
  },
  '/content/page/configuration': {
    code: 'page:configure',
    name: '页面配置',
    access: 'page:configure',
  },
  '/content/page/analytics': {
    code: 'page:analytics',
    name: '页面统计',
    access: 'page:analytics',
  },
  '/content/form': {
    code: 'customForm',
    name: '表单管理',
    access: 'customForm',
  },
  '/content/form/list': {
    code: 'customFormList',
    name: '表单列表',
    access: 'form:list',
  },
  '/content/form/submissions': {
    code: 'form:submissions',
    name: '提交明细',
    access: 'form:submissions',
  },
  '/content/form/submitters': {
    code: 'form:submitters',
    name: '提交人',
    access: 'form:submitters',
  },
  '/content/form/report': {
    code: 'form:report',
    name: '数据统计',
    access: 'form:report',
  },
  '/common': {
    code: 'common',
    name: '公共平台',
    access: 'common',
  },
  '/common/user': {
    code: 'commonUser',
    name: '用户管理',
    access: 'commonUser',
  },
  '/traffic': {
    code: 'traffic',
    name: '流量平台',
    access: 'traffic',
  },
  '/traffic/landing-page': {
    code: 'trafficLandingPage',
    name: '落地页配置',
    access: 'trafficLandingPage',
  },
  '/traffic/conversion-config': {
    code: 'trafficConversionConfig',
    name: '小程序回传配置',
    access: 'trafficConversionConfig',
  },
  '/traffic/conversion-log': {
    code: 'trafficConversionLog',
    name: '小程序回传日志',
    access: 'trafficConversionLog',
  },
  '/traffic/work-wx-contact': {
    code: 'trafficWorkWxContact',
    name: '企微加好友配置',
    access: 'trafficWorkWxContact',
  },
  '/traffic/traffic-management': {
    code: 'trafficManagement',
    name: '流量管理',
    access: 'trafficManagement',
  },
  '/traffic/traffic-management/channel-conversion': {
    code: 'channelConversion',
    name: '渠道转化数据',
    access: 'channelConversion',
  },
  '/traffic/traffic-management/channel-rules': {
    code: 'channelRules',
    name: '渠道归因规则',
    access: 'channelRules',
  },
  '/traffic/material-management': {
    code: 'trafficMaterialManagement',
    name: '素材管理',
    access: 'trafficMaterialManagement',
  },
  '/traffic/material-management/baidu': {
    code: 'thirdPlatformBaiduAccountReport',
    name: '投放报表',
    access: 'thirdPlatformBaiduAccountReport',
  },
  '/traffic/material-management/baidu-video': {
    code: 'thirdPlatformBaiduVideoReport',
    name: '百度视频报告',
    access: 'thirdPlatformBaiduVideoReport',
  },
  '/traffic/material-management/xiaohongshu': {
    code: 'thirdPlatformXiaohongshuNote',
    name: '笔记列表',
    access: 'thirdPlatformXiaohongshuNote',
  },
  '/traffic/material-management/qianchuan': {
    code: 'thirdPlatformQianchuanMaterialReport',
    name: '素材报表',
    access: 'thirdPlatformQianchuanMaterialReport',
  },
  '/traffic/material-management/ieh5': {
    code: 'thirdPlatformIeh5MaterialReport',
    name: '素材数据',
    access: 'thirdPlatformIeh5MaterialReport',
  },
  '/traffic/track': {
    code: 'trafficTrack',
    name: '例子管理',
    access: 'trafficTrack',
  },
  '/traffic/material-trace': {
    code: 'trafficMaterialTrace',
    name: '素材溯源',
    access: 'trafficMaterialTrace',
  },
  '/traffic/dashboard': {
    code: 'trafficDashboard',
    name: '投放看板',
    access: 'trafficDashboard',
  },
  '/sale': {
    code: 'sale',
    name: '营销平台',
    access: 'sale',
  },
  '/sale/sale-class': {
    code: 'saleClass',
    name: '班级管理',
    access: 'saleClass',
  },
  '/sale/sale-class-user': {
    code: 'saleClassUser',
    name: '班级成员',
    access: 'saleClassUser',
  },
  '/sale/sale-order': {
    code: 'saleOrder',
    name: '订单管理',
    access: 'saleOrder',
  },
  '/sale/sale-order/order-center': {
    code: 'dataOrderCenter',
    name: '订单中心',
    access: 'dataOrderCenter',
  },
  '/sale/sale-order/sale-manual-pay-order': {
    code: 'saleManualPayOrder',
    name: '补录订单',
    access: 'saleManualPayOrder',
  },
  '/sale/sale-order/sale-pay-order': {
    code: 'salePayOrder',
    name: '收款记录',
    access: 'salePayOrder',
  },
  '/sale/setting': {
    code: 'saleSetting',
    name: '营销配置',
    access: 'saleSetting',
  },
  '/sale/setting/sale-camp': {
    code: 'saleCamp',
    name: '营期管理',
    access: 'saleCamp',
  },
  '/frontend': {
    code: 'frontend',
    name: '销售平台',
    access: 'frontend',
  },
  '/frontend/experience-camp-users': {
    code: 'frontendExperienceCamp',
    name: '1阶用户数据明细',
    access: 'frontendExperienceCampList',
  },
  '/frontend/auto-ops': {
    code: 'frontendAutoOps',
    name: '自动化运营',
    access: 'frontendAutoOps',
  },
  '/frontend/auto-ops/hosted-wx': {
    code: 'frontendHostedWx',
    name: '托管微信号管理',
    access: 'frontendHostedWxList',
  },
  '/frontend/auto-ops/juzi-account': {
    code: 'frontendJuziAccount',
    name: '句子账号管理',
    access: 'frontendJuziAccountList',
  },
  '/frontend/auto-ops/sop-template': {
    code: 'frontendSopTemplate',
    name: '社群SOP模板',
    access: 'frontendSopTemplateList',
  },
  '/frontend/auto-ops/task': {
    code: 'frontendTask',
    name: '任务管理',
    access: 'frontendTaskList',
  },
  '/backend': {
    code: 'backend',
    name: '服务平台',
    access: 'backend',
  },
  '/backend/meeting-sales': {
    code: 'meetingSales',
    name: '会销管理',
    access: 'meetingSales',
  },
  '/backend/meeting-sales/activity': {
    code: 'meetingSalesActivity',
    name: '场次管理',
    access: 'meetingSalesActivityWorkspace',
  },
  '/backend/meeting-sales/hotel': {
    code: 'meetingSalesHotel',
    name: '酒店管理',
    access: 'meetingSalesHotelWorkspace',
  },
  '/backend/meeting-sales/activity/detail': {
    code: 'meetingSalesActivityDetail',
    name: '场次详情',
    access: 'meetingSalesActivityWorkspace',
  },
  '/backend/meeting-sales/hotel/detail': {
    code: 'meetingSalesHotelDetail',
    name: '酒店详情',
    access: 'meetingSalesHotelWorkspace',
  },
  '/backend/level-2-users': {
    code: 'backendLevel2Users',
    name: '2阶用户数据明细',
    access: 'backendLevel2Users',
  },
  '/backend/level-3-users': {
    code: 'backendLevel3Users',
    name: '3阶用户数据明细',
    access: 'backendLevel3Users',
  },
  '/backend/level-4-users': {
    code: 'backendLevel4Users',
    name: '4阶用户数据明细',
    access: 'backendLevel4Users',
  },
  '/backend/backend-order': {
    code: 'backendOrder',
    name: '订单管理',
    access: 'backendOrder',
  },
  '/backend/backend-order/backend-manual-pay-order': {
    code: 'backendManualPayOrder',
    name: '补录订单',
    access: 'backendManualPayOrder',
  },
  '/backend/backend-order/backend-pay-order': {
    code: 'backendPayOrder',
    name: '收款记录',
    access: 'backendPayOrder',
  },
  '/backend/setting': {
    code: 'backendSetting',
    name: '后端配置',
    access: 'backendSetting',
  },
  '/backend/setting/backend-camp': {
    code: 'backendCamp',
    name: '场次管理',
    access: 'backendCamp',
  },
  '/backend/member': {
    code: 'backendMember',
    name: '成员管理',
    access: 'backendMember',
  },
  '/backend/member/backend-member-user': {
    code: 'backendMemberUser',
    name: '后端成员',
    access: 'backendMemberUser',
  },
  '/bill': {
    code: 'bill',
    name: '财务中台',
    access: 'bill',
  },
  '/bill/sale-order': {
    code: 'billSaleOrder',
    name: '营销订单',
    access: 'billSaleOrder',
  },
  '/bill/sale-order/sale-manual-pay-order': {
    code: 'billSaleManualPayOrder',
    name: '营销补录订单',
    access: 'billSaleManualPayOrder',
  },
  '/bill/sale-order/sale-pay-order': {
    code: 'billSalePayOrder',
    name: '营销收款',
    access: 'billSalePayOrder',
  },
  '/bill/backend-order': {
    code: 'billBackendOrder',
    name: '后端订单',
    access: 'billBackendOrder',
  },
  '/bill/backend-order/backend-manual-pay-order': {
    code: 'billBackendManualPayOrder',
    name: '后端补录订单',
    access: 'billBackendManualPayOrder',
  },
  '/bill/backend-order/backend-pay-order': {
    code: 'billBackendPayOrder',
    name: '后端收款',
    access: 'billBackendPayOrder',
  },
  '/bill/statement': {
    code: 'billStatement',
    name: '账单',
    access: 'billStatement',
  },
  '/bill/statement/bank-statement': {
    code: 'billBankStatement',
    name: '银行流水',
    access: 'billBankStatement',
  },
  '/bill/statement/tang-lang-statement': {
    code: 'billTangLangStatement',
    name: '螳螂流水',
    access: 'billTangLangStatement',
  },
  '/bill/statement/order': {
    code: 'billStatementOrder',
    name: '全部订单',
    access: 'billStatementOrder',
  },
  '/bill/statement/landing-page-order': {
    code: 'billLandingPageOrder',
    name: '落地页订单',
    access: 'billLandingPageOrder',
  },
  '/bill/statement/work-wx-order': {
    code: 'billWorkWxOrder',
    name: '企微收款订单',
    access: 'billWorkWxOrder',
  },
  '/data': {
    code: 'data',
    name: '数据中台',
    access: 'data',
  },
  '/data/customer-management': {
    code: 'dataCustomerManagement',
    name: '客户管理',
    access: 'dataCustomerManagement',
  },
  '/data/customer-management/customer-list': {
    code: 'dataCustomerList',
    name: '客户列表',
    access: 'dataCustomerList',
  },
  '/data/customer-management/customer-field': {
    code: 'dataCustomerField',
    name: '客户字段',
    access: 'dataCustomerField',
  },
  '/data/customer-management/customer-tag': {
    code: 'dataCustomerTag',
    name: '客户标签',
    access: 'dataCustomerTag',
  },
  '/data/customer-management/customer-stage': {
    code: 'dataCustomerStage',
    name: '客户阶段',
    access: 'dataCustomerStage',
  },
  '/data/customer-management/customer-source': {
    code: 'dataCustomerSource',
    name: '来源管理',
    access: 'dataCustomerSource',
  },
  '/data/customer-management/customer-channel': {
    code: 'dataCustomerChannel',
    name: '渠道管理',
    access: 'dataCustomerChannel',
  },
  '/data/automation-workflow': {
    code: 'dataAutomationWorkflow',
    name: '自动化工作流',
    access: 'dataAutomationWorkflow',
  },
  '/data/automation-workflow/workflow-list': {
    code: 'dataWorkflow',
    name: '工作流列表',
    access: 'dataWorkflow',
  },
  '/data/automation-workflow/workflow-config/:id': {
    code: 'dataWorkflow',
    name: '工作流列表',
    access: 'dataWorkflow',
  },
  '/data/track': {
    code: 'dataTrack',
    name: '全链路用户数据',
    access: 'dataTrack',
  },
  '/third-platform': {
    code: 'thirdPlatform',
    name: '第三方平台',
    access: 'thirdPlatformNavigation',
  },
  '/third-platform/tencent-ad': {
    code: 'thirdPlatformTencentAd',
    name: '腾讯广告',
    access: 'thirdPlatformTencentAd',
  },
  '/third-platform/tencent-ad/access': {
    code: 'thirdPlatformTencentAdAccess',
    name: '接入管理',
    access: 'thirdPlatformTencentAdAccess',
  },
  '/third-platform/tencent-ad/reports': {
    code: 'thirdPlatformTencentAdReports',
    name: '账户日报',
    access: 'thirdPlatformTencentAdReports',
  },
  '/third-platform/map-service': {
    code: 'thirdPlatformMapService',
    name: '地图服务',
    access: 'thirdPlatformMapService',
  },
  '/third-platform/map-service/settings': {
    code: 'thirdPlatformMapSettings',
    name: '定位配置',
    access: 'thirdPlatformMapSettings',
  },
  '/third-platform/map-service/tencent': {
    code: 'thirdPlatformMapTencent',
    name: '腾讯地图',
    access: 'thirdPlatformMapTencent',
  },
  '/third-platform/map-service/amap': {
    code: 'thirdPlatformMapAmap',
    name: '高德地图',
    access: 'thirdPlatformMapAmap',
  },
  '/third-platform/xing-cheng': {
    code: 'thirdPlatformXingCheng',
    name: '星橙',
    access: 'thirdPlatformXingCheng',
  },
  '/third-platform/xing-cheng/traffic-order': {
    code: 'thirdPlatformXingChengTrafficOrder',
    name: '例子订单',
    access: 'thirdPlatformXingChengTrafficOrder',
  },
  '/third-platform/xing-cheng/account': {
    code: 'thirdPlatformXingChengAccount',
    name: '星橙账号',
    access: 'thirdPlatformXingChengAccount',
  },
  '/third-platform/tang-lang': {
    code: 'thirdPlatformTangLang',
    name: '螳螂',
    access: 'thirdPlatformTangLang',
  },
  '/third-platform/tang-lang/scheduled-task': {
    code: 'thirdPlatformTangLangScheduledTask',
    name: '定时任务',
    access: 'thirdPlatformTangLangScheduledTask',
  },
  '/third-platform/tang-lang/account': {
    code: 'thirdPlatformTangLangAccount',
    name: '螳螂账号',
    access: 'thirdPlatformTangLangAccount',
  },
  '/third-platform/tang-lang/product': {
    code: 'thirdPlatformTangLangProduct',
    name: '商品列表',
    access: 'thirdPlatformTangLangProduct',
  },
  '/third-platform/tang-lang/traffic-order': {
    code: 'thirdPlatformTangLangTrafficOrder',
    name: '例子订单',
    access: 'thirdPlatformTangLangTrafficOrder',
  },
  '/third-platform/tang-lang/customer': {
    code: 'thirdPlatformTangLangCustomer',
    name: '客户数据',
    access: 'thirdPlatformTangLangCustomer',
  },
  '/third-platform/tang-lang/refund-order': {
    code: 'thirdPlatformTangLangRefundOrder',
    name: '退款订单',
    access: 'thirdPlatformTangLangRefundOrder',
  },
  '/third-platform/tang-lang/pay-order': {
    code: 'thirdPlatformTangLangPayOrder',
    name: '支付订单',
    access: 'thirdPlatformTangLangPayOrder',
  },
  '/third-platform/tang-lang/camp-learning': {
    code: 'thirdPlatformTangLangCampLearning',
    name: '训练营',
    access: 'thirdPlatformTangLangCampLearning',
  },
  '/third-platform/fei-shu': {
    code: 'thirdPlatformFeiShu',
    name: '飞书',
    access: 'thirdPlatformFeiShuNavigation',
  },
  '/third-platform/fei-shu/traffic-order': {
    code: 'thirdPlatformFeiShuTrafficOrder',
    name: '例子订单',
    access: 'thirdPlatformFeiShuTrafficOrder',
  },
  '/third-platform/fei-shu/sale-order': {
    code: 'thirdPlatformFeiShuSaleOrder',
    name: '销售订单',
    access: 'thirdPlatformFeiShuSaleOrder',
  },
  '/third-platform/fei-shu/backend-sale-order': {
    code: 'thirdPlatformFeiShuBackendSaleOrder',
    name: '后端销售订单',
    access: 'thirdPlatformFeiShuBackendSaleOrder',
  },
  '/third-platform/fei-shu/rpa-order': {
    code: 'thirdPlatformFeiShuRpaOrder',
    name: 'RPA订单',
    access: 'thirdPlatformFeiShuRpaOrder',
  },
  '/third-platform/fei-shu/table-record': {
    code: 'thirdPlatformFeiShuTableRecord',
    name: '飞书记录',
    access: 'thirdPlatformFeiShuTableRecord',
  },
  '/third-platform/work-wx': {
    code: 'thirdPlatformWorkWx',
    name: '企业微信',
    access: 'thirdPlatformWorkWxNavigation',
  },
  '/third-platform/work-wx/corp': {
    code: 'thirdPlatformWorkWxCorp',
    name: '企业',
    access: 'thirdPlatformWorkWxCorpWorkspace',
  },
  '/third-platform/work-wx/user': {
    code: 'thirdPlatformWorkWxUser',
    name: '成员',
    access: 'thirdPlatformWorkWxMemberWorkspace',
  },
  '/third-platform/work-wx/external-user': {
    code: 'thirdPlatformWorkWxExternalUser',
    name: '客户',
    access: 'thirdPlatformWorkWxContactWorkspace',
  },
  '/third-platform/work-wx/follow-user': {
    code: 'thirdPlatformWorkWxFollowUser',
    name: '跟进关系',
    access: 'thirdPlatformWorkWxFollowUser',
  },
  '/third-platform/work-wx/external-pay-bill': {
    code: 'thirdPlatformWorkWxExternalPayBill',
    name: '对外收款账单',
    access: 'thirdPlatformWorkWxExternalPayBill',
  },
  '/third-platform/work-wx/external-refund-order': {
    code: 'thirdPlatformWorkWxExternalRefundOrder',
    name: '企微退款订单',
    access: 'thirdPlatformWorkWxExternalRefundOrder',
  },
  '/third-platform/work-wx/fund-flow': {
    code: 'thirdPlatformWorkWxFundFlow',
    name: '资金流水',
    access: 'thirdPlatformWorkWxFundFlow',
  },
  '/third-platform/wechat-pay': {
    code: 'thirdPlatformWechatPay',
    name: '微信支付',
    access: 'thirdPlatformWechatPay',
  },
  '/third-platform/wechat-pay/merchant-account': {
    code: 'thirdPlatformWechatPayMerchant',
    name: '商户账号',
    access: 'thirdPlatformWechatPayMerchant',
  },
  '/third-platform/wechat-pay/fund-flow': {
    code: 'thirdPlatformWechatPayFundFlow',
    name: '资金流水',
    access: 'thirdPlatformWechatPayFundFlow',
  },
  '/third-platform/wechat-pay/trade-bill': {
    code: 'thirdPlatformWechatPayTradeBill',
    name: '交易账单',
    access: 'thirdPlatformWechatPayTradeBill',
  },
  '/third-platform/zhu-ge': {
    code: 'thirdPlatformZhuGe',
    name: '诸葛',
    access: 'thirdPlatformZhuGe',
  },
  '/third-platform/zhu-ge/order': {
    code: 'thirdPlatformZhuGeOrder',
    name: '诸葛订单',
    access: 'thirdPlatformZhuGeOrder',
  },
  '/third-platform/zhu-ge/author-report-day': {
    code: 'thirdPlatformZhuGeAuthorReportDay',
    name: '作者日报',
    access: 'thirdPlatformZhuGeAuthorReportDay',
  },
  '/third-platform/zhu-ge/author-video-plan-day': {
    code: 'thirdPlatformZhuGeAuthorVideoPlanDay',
    name: '作者计划日报',
    access: 'thirdPlatformZhuGeAuthorVideoPlanDay',
  },
  '/third-platform/zhu-ge/report-day': {
    code: 'thirdPlatformZhuGeReportDay',
    name: '投放日报',
    access: 'thirdPlatformZhuGeReportDay',
  },
  '/third-platform/wx-shop': {
    code: 'thirdPlatformWxShop',
    name: '微信小店',
    access: 'thirdPlatformWxShop',
  },
  '/third-platform/wx-shop/funds-flow': {
    code: 'thirdPlatformWxShopFundsFlow',
    name: '资金流水',
    access: 'thirdPlatformWxShopFundsFlow',
  },
  '/third-platform/wx-shop/order-flow': {
    code: 'thirdPlatformWxShopOrderFlow',
    name: '订单流水',
    access: 'thirdPlatformWxShopOrderFlow',
  },
  '/third-platform/dou-gong': {
    code: 'thirdPlatformDouGong',
    name: '斗拱平台',
    access: 'thirdPlatformDouGong',
  },
  '/third-platform/dou-gong/trade-bill': {
    code: 'thirdPlatformDouGongTradeBill',
    name: '交易账单',
    access: 'thirdPlatformDouGongTradeBill',
  },
  '/third-platform/bank': {
    code: 'thirdPlatformBank',
    name: '银行',
    access: 'thirdPlatformBank',
  },
  '/third-platform/bank/union-pay-flow': {
    code: 'thirdPlatformBankUnionPayFlow',
    name: '银联流水',
    access: 'thirdPlatformBankUnionPayFlow',
  },
  '/third-platform/baidu': {
    code: 'thirdPlatformBaidu',
    name: '百度',
    access: 'thirdPlatformBaidu',
  },
  '/third-platform/baidu/app': {
    code: 'thirdPlatformBaiduApp',
    name: '应用列表',
    access: 'thirdPlatformBaiduApp',
  },
  '/third-platform/baidu/authorization': {
    code: 'thirdPlatformBaiduAuthorization',
    name: '授权账号',
    access: 'thirdPlatformBaiduAuthorization',
  },
  '/third-platform/baidu/account-report': {
    code: 'thirdPlatformBaiduAccountReport',
    name: '投放报表',
    access: 'thirdPlatformBaiduAccountReport',
  },
  '/third-platform/baidu/video-report': {
    code: 'thirdPlatformBaiduVideoReport',
    name: '百度视频报告',
    access: 'thirdPlatformBaiduVideoReport',
  },
  '/third-platform/xiaohongshu': {
    code: 'thirdPlatformXiaohongshu',
    name: '小红书',
    access: 'thirdPlatformXiaohongshu',
  },
  '/third-platform/xiaohongshu/app': {
    code: 'thirdPlatformXiaohongshuApp',
    name: '应用列表',
    access: 'thirdPlatformXiaohongshuApp',
  },
  '/third-platform/xiaohongshu/authorization': {
    code: 'thirdPlatformXiaohongshuAuthorization',
    name: '授权账号',
    access: 'thirdPlatformXiaohongshuAuthorization',
  },
  '/third-platform/xiaohongshu/account': {
    code: 'thirdPlatformXiaohongshuAccount',
    name: '投放账号',
    access: 'thirdPlatformXiaohongshuAccount',
  },
  '/third-platform/xiaohongshu/note-list': {
    code: 'thirdPlatformXiaohongshuNote',
    name: '笔记列表',
    access: 'thirdPlatformXiaohongshuNote',
  },
  '/third-platform/xiaohongshu/account-report': {
    code: 'thirdPlatformXiaohongshuAccountReport',
    name: '账户报表',
    access: 'thirdPlatformXiaohongshuAccountReport',
  },
  '/third-platform/xiaohongshu/campaign-report': {
    code: 'thirdPlatformXiaohongshuCampaignReport',
    name: '计划报表',
    access: 'thirdPlatformXiaohongshuCampaignReport',
  },
  '/third-platform/xiaohongshu/creative-report': {
    code: 'thirdPlatformXiaohongshuCreativeReport',
    name: '素材报表',
    access: 'thirdPlatformXiaohongshuCreativeReport',
  },
  '/third-platform/qianchuan': {
    code: 'thirdPlatformQianchuan',
    name: '巨量千川',
    access: 'thirdPlatformQianchuan',
  },
  '/third-platform/qianchuan/app': {
    code: 'thirdPlatformQianchuanApp',
    name: '应用列表',
    access: 'thirdPlatformQianchuanApp',
  },
  '/third-platform/qianchuan/authorization': {
    code: 'thirdPlatformQianchuanAuthorization',
    name: '授权账号',
    access: 'thirdPlatformQianchuanAuthorization',
  },
  '/third-platform/qianchuan/authorized-account': {
    code: 'thirdPlatformQianchuanAuthorizedAccount',
    name: '授权主体',
    access: 'thirdPlatformQianchuanAuthorizedAccount',
  },
  '/third-platform/qianchuan/account': {
    code: 'thirdPlatformQianchuanAccount',
    name: '投放账号',
    access: 'thirdPlatformQianchuanAccount',
  },
  '/third-platform/qianchuan/account-report': {
    code: 'thirdPlatformQianchuanAccountReport',
    name: '报表明细',
    access: 'thirdPlatformQianchuanAccountReport',
  },
  '/third-platform/qianchuan/report-summary': {
    code: 'thirdPlatformQianchuanReportSummary',
    name: '报表汇总',
    access: 'thirdPlatformQianchuanReportSummary',
  },
  '/third-platform/qianchuan/material-report': {
    code: 'thirdPlatformQianchuanMaterialReport',
    name: '素材报表',
    access: 'thirdPlatformQianchuanMaterialReport',
  },
  '/third-platform/ieh5': {
    code: 'thirdPlatformIeh5',
    name: '海豚',
    access: 'thirdPlatformIeh5',
  },
  '/third-platform/ieh5/account': {
    code: 'thirdPlatformIeh5Account',
    name: '账号配置',
    access: 'thirdPlatformIeh5Account',
  },
  '/third-platform/ieh5/ad-account': {
    code: 'thirdPlatformIeh5AdAccount',
    name: '投放号',
    access: 'thirdPlatformIeh5AdAccount',
  },
  '/third-platform/ieh5/order-management': {
    code: 'thirdPlatformIeh5OrderManagement',
    name: '订单管理',
    access: 'thirdPlatformIeh5OrderManagement',
  },
  '/third-platform/ieh5/issued-data': {
    code: 'thirdPlatformIeh5IssuedData',
    name: '出单数据',
    access: 'thirdPlatformIeh5IssuedData',
  },
  '/third-platform/ieh5/material-attribution': {
    code: 'thirdPlatformIeh5MaterialAttribution',
    name: '素材溯源结果',
    access: 'thirdPlatformIeh5MaterialAttribution',
  },
  '/third-platform/ieh5/operation-report': {
    code: 'thirdPlatformIeh5OperationReport',
    name: '运营报表-视频',
    access: 'thirdPlatformIeh5OperationReport',
  },
  '/third-platform/ieh5/operation-shipinhao-report': {
    code: 'thirdPlatformIeh5ShipinhaoReport',
    name: '运营报表-投放号',
    access: 'thirdPlatformIeh5ShipinhaoReport',
  },
  '/third-platform/ieh5/finance-report': {
    code: 'thirdPlatformIeh5FinanceReport',
    name: '财务报表',
    access: 'thirdPlatformIeh5FinanceReport',
  },
  '/third-platform/ieh5/placement-data': {
    code: 'thirdPlatformIeh5PlacementData',
    name: '投放数据',
    access: 'thirdPlatformIeh5PlacementData',
  },
  '/third-platform/ieh5/material-report': {
    code: 'thirdPlatformIeh5MaterialReport',
    name: '素材数据',
    access: 'thirdPlatformIeh5MaterialReport',
  },
  '/system': {
    code: 'system',
    name: '系统设置',
    access: 'system',
  },
  '/system/project-management': {
    code: 'projectManagement',
    name: '项目管理',
    access: 'projectManagement',
  },
  '/system/project-management/project-list': {
    code: 'projectList',
    name: '项目列表',
    access: 'projectList',
  },
  '/system/course': {
    code: 'systemCourse',
    name: '训练营管理',
    access: 'systemCourse',
  },
  '/system/course-period': {
    code: 'systemCoursePeriod',
    name: '营期管理',
    access: 'systemCoursePeriod',
  },
  '/system/product': {
    code: 'systemProduct',
    name: '商品管理',
    access: 'systemProduct',
  },
  '/system/channel': {
    code: 'systemChannel',
    name: '渠道管理',
    access: 'systemChannel',
  },
  '/system/team': {
    code: 'systemTeam',
    name: '团队管理',
    access: 'systemTeam',
  },
  '/system/team/member': {
    code: 'systemDepartment',
    name: '成员管理',
    access: 'systemDepartment',
  },
  '/system/team/role': {
    code: 'systemRole',
    name: '角色管理',
    access: 'systemRole',
  },
  '/system/team/permission': {
    code: 'systemPermission',
    name: '权限管理',
    access: 'systemPermission',
  },
  '/system/team/data-permission': {
    code: 'systemDataPermissionRoute',
    name: '数据权限管理',
    access: 'systemDataPermissionRoute',
  },
  '/system/employee': {
    code: 'systemEmployee',
    name: '员工管理',
    access: 'systemEmployee',
  },
  '/system/data-protection': {
    code: 'systemDataProtection',
    name: '数据保护',
    access: 'systemDataProtection',
  },
  '/system/fei-shu-table-config-mapping': {
    code: 'systemFeiShuTableConfigMapping',
    name: '飞书表格映射',
    access: 'systemFeiShuTableConfigMapping',
  },
  '/system/material-library': {
    code: 'materialLibrary',
    name: '素材库',
    access: 'material:list',
  },
  '/system/short-link': {
    code: 'shortLink',
    name: '短链管理',
    access: 'short-link:list',
  },
  '/system/mcp': {
    code: 'systemMcp',
    name: 'MCP 管理',
    access: 'systemMcp',
  },
  '/system/operation-log': {
    code: 'systemOperationLog',
    name: '操作日志',
    access: 'systemOperationLog',
  },
  '/backend/meeting-sales/room': {
    code: 'meetingSalesRoom',
    name: '房型管理',
    access: 'meetingSalesRoomList',
  },
  '/backend/meeting-sales/registration': {
    code: 'meetingSalesRegistration',
    name: '报名与签到',
    access: 'meetingSalesRegistrationList',
  },
  '/backend/meeting-sales/booking': {
    code: 'meetingSalesBooking',
    name: '酒店预约',
    access: 'meetingSalesBookingList',
  },
  '/backend/meeting-sales/rooming': {
    code: 'meetingSalesRooming',
    name: '拼房管理',
    access: 'meetingSalesRoomingList',
  },
  '/backend/meeting-sales/group': {
    code: 'meetingSalesGroup',
    name: '分组管理',
    access: 'meetingSalesGroupList',
  },
  '/backend/meeting-sales/members': {
    code: 'meetingSalesMembers',
    name: '分组成员',
    access: 'meetingSalesMembersList',
  },
  '/frontend/auto-ops/hosted-wx-zhonghui': {
    code: 'frontendHostedWxZhonghui',
    name: '托管微信号管理（中荟）',
    access: 'frontendHostedWxList',
  },
  '/frontend/auto-ops/sop-template/edit': {
    code: 'frontendSopTemplateCreate',
    name: '新建模板',
    access: 'frontendSopTemplateCreate',
  },
  '/frontend/auto-ops/sop-template/edit/:id': {
    code: 'frontendSopTemplateEdit',
    name: '编辑模板',
    access: 'frontendSopTemplateEdit',
  },
  '/frontend/auto-ops/task/create': {
    code: 'frontendTaskCreate',
    name: '新建任务',
    access: 'frontendTaskCreate',
  },
  '/frontend/auto-ops/task/detail/:id': {
    code: 'frontendTaskList',
    name: '任务详情',
    access: 'frontendTaskList',
  },
  '/backend/meeting-sales/forms': {
    code: 'form:list',
    name: '问卷模板与填写记录',
    access: 'form:list',
  },
  '/third-platform/wechat': {
    code: 'thirdPlatformWechat',
    name: '微信',
    access: 'thirdPlatformWechatNavigation',
  },
  '/third-platform/wechat/public-accounts': {
    code: 'systemWechatPublicAccounts',
    name: '微信公众号',
    access: 'systemWechatPublicAccounts',
  },
  '/third-platform/wechat/mini-programs': {
    code: 'systemWechatApps',
    name: '微信小程序',
    access: 'systemWechatApps',
  },
  '/third-platform/work-wx/group-chat': {
    code: 'thirdPlatformWorkWxGroupChat',
    name: '客户群',
    access: 'thirdPlatformWorkWxGroupWorkspace',
  },
  '/third-platform/fei-shu/apps': {
    code: 'systemFeiShuApps',
    name: '应用管理',
    access: 'systemFeiShuApps',
  },
};
export const menuNavigationDependencies: Record<string, string[]> = {
  content: [
    'customPage',
    'page:list',
    'page:configure',
    'page:analytics',
    'customForm',
    'form:list',
    'form:submissions',
    'form:submitters',
    'form:report',
  ],
  customPage: ['page:list', 'page:configure', 'page:analytics'],
  customForm: [
    'form:list',
    'form:submissions',
    'form:submitters',
    'form:report',
  ],
  common: ['commonUser'],
  traffic: [
    'trafficLandingPage',
    'trafficConversionConfig',
    'trafficConversionLog',
    'trafficWorkWxContact',
    'trafficManagement',
    'channelConversion',
    'channelRules',
    'trafficMaterialManagement',
    'thirdPlatformBaiduAccountReport',
    'thirdPlatformBaiduVideoReport',
    'thirdPlatformXiaohongshuNote',
    'thirdPlatformQianchuanMaterialReport',
    'thirdPlatformIeh5MaterialReport',
    'trafficTrack',
    'trafficMaterialTrace',
    'trafficDashboard',
  ],
  trafficManagement: ['channelConversion', 'channelRules'],
  trafficMaterialManagement: [
    'thirdPlatformBaiduAccountReport',
    'thirdPlatformBaiduVideoReport',
    'thirdPlatformXiaohongshuNote',
    'thirdPlatformQianchuanMaterialReport',
    'thirdPlatformIeh5MaterialReport',
  ],
  sale: [
    'saleClass',
    'saleClassUser',
    'saleOrder',
    'dataOrderCenter',
    'saleManualPayOrder',
    'salePayOrder',
    'saleSetting',
    'saleCamp',
  ],
  saleOrder: ['dataOrderCenter', 'saleManualPayOrder', 'salePayOrder'],
  saleSetting: ['saleCamp'],
  frontend: [
    'frontendExperienceCampList',
    'frontendAutoOps',
    'frontendHostedWxList',
    'frontendJuziAccountList',
    'frontendSopTemplateList',
    'frontendTaskList',
    'frontendSopTemplateCreate',
    'frontendSopTemplateEdit',
    'frontendTaskCreate',
  ],
  frontendAutoOps: [
    'frontendHostedWxList',
    'frontendJuziAccountList',
    'frontendSopTemplateList',
    'frontendTaskList',
    'frontendSopTemplateCreate',
    'frontendSopTemplateEdit',
    'frontendTaskCreate',
  ],
  frontendSopTemplate: ['frontendSopTemplateCreate', 'frontendSopTemplateEdit'],
  frontendSopTemplateList: [
    'frontendSopTemplateCreate',
    'frontendSopTemplateEdit',
  ],
  frontendTask: ['frontendTaskCreate', 'frontendTaskList'],
  frontendTaskList: ['frontendTaskCreate', 'frontendTaskList'],
  backend: [
    'meetingSales',
    'meetingSalesActivityWorkspace',
    'meetingSalesHotelWorkspace',
    'backendLevel2Users',
    'backendLevel3Users',
    'backendLevel4Users',
    'backendOrder',
    'backendManualPayOrder',
    'backendPayOrder',
    'backendSetting',
    'backendCamp',
    'backendMember',
    'backendMemberUser',
    'meetingSalesRoomList',
    'meetingSalesRegistrationList',
    'meetingSalesBookingList',
    'meetingSalesRoomingList',
    'meetingSalesGroupList',
    'meetingSalesMembersList',
    'form:list',
  ],
  meetingSales: [
    'meetingSalesActivityWorkspace',
    'meetingSalesHotelWorkspace',
    'meetingSalesRoomList',
    'meetingSalesRegistrationList',
    'meetingSalesBookingList',
    'meetingSalesRoomingList',
    'meetingSalesGroupList',
    'meetingSalesMembersList',
    'form:list',
  ],
  meetingSalesActivity: ['meetingSalesActivityWorkspace'],
  meetingSalesActivityWorkspace: ['meetingSalesActivityWorkspace'],
  meetingSalesHotel: ['meetingSalesHotelWorkspace'],
  meetingSalesHotelWorkspace: ['meetingSalesHotelWorkspace'],
  backendOrder: ['backendManualPayOrder', 'backendPayOrder'],
  backendSetting: ['backendCamp'],
  backendMember: ['backendMemberUser'],
  bill: [
    'billSaleOrder',
    'billSaleManualPayOrder',
    'billSalePayOrder',
    'billBackendOrder',
    'billBackendManualPayOrder',
    'billBackendPayOrder',
    'billStatement',
    'billBankStatement',
    'billTangLangStatement',
    'billStatementOrder',
    'billLandingPageOrder',
    'billWorkWxOrder',
  ],
  billSaleOrder: ['billSaleManualPayOrder', 'billSalePayOrder'],
  billBackendOrder: ['billBackendManualPayOrder', 'billBackendPayOrder'],
  billStatement: [
    'billBankStatement',
    'billTangLangStatement',
    'billStatementOrder',
    'billLandingPageOrder',
    'billWorkWxOrder',
  ],
  data: [
    'dataCustomerManagement',
    'dataCustomerList',
    'dataCustomerField',
    'dataCustomerTag',
    'dataCustomerStage',
    'dataCustomerSource',
    'dataCustomerChannel',
    'dataAutomationWorkflow',
    'dataWorkflow',
    'dataTrack',
  ],
  dataCustomerManagement: [
    'dataCustomerList',
    'dataCustomerField',
    'dataCustomerTag',
    'dataCustomerStage',
    'dataCustomerSource',
    'dataCustomerChannel',
  ],
  dataAutomationWorkflow: ['dataWorkflow'],
  thirdPlatform: [
    'thirdPlatformTencentAd',
    'thirdPlatformTencentAdAccess',
    'thirdPlatformTencentAdReports',
    'thirdPlatformMapService',
    'thirdPlatformMapSettings',
    'thirdPlatformMapTencent',
    'thirdPlatformMapAmap',
    'thirdPlatformXingCheng',
    'thirdPlatformXingChengTrafficOrder',
    'thirdPlatformXingChengAccount',
    'thirdPlatformTangLang',
    'thirdPlatformTangLangScheduledTask',
    'thirdPlatformTangLangAccount',
    'thirdPlatformTangLangProduct',
    'thirdPlatformTangLangTrafficOrder',
    'thirdPlatformTangLangCustomer',
    'thirdPlatformTangLangRefundOrder',
    'thirdPlatformTangLangPayOrder',
    'thirdPlatformTangLangCampLearning',
    'thirdPlatformFeiShuNavigation',
    'thirdPlatformFeiShuTrafficOrder',
    'thirdPlatformFeiShuSaleOrder',
    'thirdPlatformFeiShuBackendSaleOrder',
    'thirdPlatformFeiShuRpaOrder',
    'thirdPlatformFeiShuTableRecord',
    'thirdPlatformWorkWxNavigation',
    'thirdPlatformWorkWxCorpWorkspace',
    'thirdPlatformWorkWxMemberWorkspace',
    'thirdPlatformWorkWxContactWorkspace',
    'thirdPlatformWorkWxFollowUser',
    'thirdPlatformWorkWxExternalPayBill',
    'thirdPlatformWorkWxExternalRefundOrder',
    'thirdPlatformWorkWxFundFlow',
    'thirdPlatformWechatPay',
    'thirdPlatformWechatPayMerchant',
    'thirdPlatformWechatPayFundFlow',
    'thirdPlatformWechatPayTradeBill',
    'thirdPlatformZhuGe',
    'thirdPlatformZhuGeOrder',
    'thirdPlatformZhuGeAuthorReportDay',
    'thirdPlatformZhuGeAuthorVideoPlanDay',
    'thirdPlatformZhuGeReportDay',
    'thirdPlatformWxShop',
    'thirdPlatformWxShopFundsFlow',
    'thirdPlatformWxShopOrderFlow',
    'thirdPlatformDouGong',
    'thirdPlatformDouGongTradeBill',
    'thirdPlatformBank',
    'thirdPlatformBankUnionPayFlow',
    'thirdPlatformBaidu',
    'thirdPlatformBaiduApp',
    'thirdPlatformBaiduAuthorization',
    'thirdPlatformBaiduAccountReport',
    'thirdPlatformBaiduVideoReport',
    'thirdPlatformXiaohongshu',
    'thirdPlatformXiaohongshuApp',
    'thirdPlatformXiaohongshuAuthorization',
    'thirdPlatformXiaohongshuAccount',
    'thirdPlatformXiaohongshuNote',
    'thirdPlatformXiaohongshuAccountReport',
    'thirdPlatformXiaohongshuCampaignReport',
    'thirdPlatformXiaohongshuCreativeReport',
    'thirdPlatformQianchuan',
    'thirdPlatformQianchuanApp',
    'thirdPlatformQianchuanAuthorization',
    'thirdPlatformQianchuanAuthorizedAccount',
    'thirdPlatformQianchuanAccount',
    'thirdPlatformQianchuanAccountReport',
    'thirdPlatformQianchuanReportSummary',
    'thirdPlatformQianchuanMaterialReport',
    'thirdPlatformIeh5',
    'thirdPlatformIeh5Account',
    'thirdPlatformIeh5AdAccount',
    'thirdPlatformIeh5OrderManagement',
    'thirdPlatformIeh5IssuedData',
    'thirdPlatformIeh5MaterialAttribution',
    'thirdPlatformIeh5OperationReport',
    'thirdPlatformIeh5ShipinhaoReport',
    'thirdPlatformIeh5FinanceReport',
    'thirdPlatformIeh5PlacementData',
    'thirdPlatformIeh5MaterialReport',
    'thirdPlatformWechatNavigation',
    'systemWechatPublicAccounts',
    'systemWechatApps',
    'thirdPlatformWorkWxGroupWorkspace',
    'systemFeiShuApps',
  ],
  thirdPlatformNavigation: [
    'thirdPlatformTencentAd',
    'thirdPlatformTencentAdAccess',
    'thirdPlatformTencentAdReports',
    'thirdPlatformMapService',
    'thirdPlatformMapSettings',
    'thirdPlatformMapTencent',
    'thirdPlatformMapAmap',
    'thirdPlatformXingCheng',
    'thirdPlatformXingChengTrafficOrder',
    'thirdPlatformXingChengAccount',
    'thirdPlatformTangLang',
    'thirdPlatformTangLangScheduledTask',
    'thirdPlatformTangLangAccount',
    'thirdPlatformTangLangProduct',
    'thirdPlatformTangLangTrafficOrder',
    'thirdPlatformTangLangCustomer',
    'thirdPlatformTangLangRefundOrder',
    'thirdPlatformTangLangPayOrder',
    'thirdPlatformTangLangCampLearning',
    'thirdPlatformFeiShuNavigation',
    'thirdPlatformFeiShuTrafficOrder',
    'thirdPlatformFeiShuSaleOrder',
    'thirdPlatformFeiShuBackendSaleOrder',
    'thirdPlatformFeiShuRpaOrder',
    'thirdPlatformFeiShuTableRecord',
    'thirdPlatformWorkWxNavigation',
    'thirdPlatformWorkWxCorpWorkspace',
    'thirdPlatformWorkWxMemberWorkspace',
    'thirdPlatformWorkWxContactWorkspace',
    'thirdPlatformWorkWxFollowUser',
    'thirdPlatformWorkWxExternalPayBill',
    'thirdPlatformWorkWxExternalRefundOrder',
    'thirdPlatformWorkWxFundFlow',
    'thirdPlatformWechatPay',
    'thirdPlatformWechatPayMerchant',
    'thirdPlatformWechatPayFundFlow',
    'thirdPlatformWechatPayTradeBill',
    'thirdPlatformZhuGe',
    'thirdPlatformZhuGeOrder',
    'thirdPlatformZhuGeAuthorReportDay',
    'thirdPlatformZhuGeAuthorVideoPlanDay',
    'thirdPlatformZhuGeReportDay',
    'thirdPlatformWxShop',
    'thirdPlatformWxShopFundsFlow',
    'thirdPlatformWxShopOrderFlow',
    'thirdPlatformDouGong',
    'thirdPlatformDouGongTradeBill',
    'thirdPlatformBank',
    'thirdPlatformBankUnionPayFlow',
    'thirdPlatformBaidu',
    'thirdPlatformBaiduApp',
    'thirdPlatformBaiduAuthorization',
    'thirdPlatformBaiduAccountReport',
    'thirdPlatformBaiduVideoReport',
    'thirdPlatformXiaohongshu',
    'thirdPlatformXiaohongshuApp',
    'thirdPlatformXiaohongshuAuthorization',
    'thirdPlatformXiaohongshuAccount',
    'thirdPlatformXiaohongshuNote',
    'thirdPlatformXiaohongshuAccountReport',
    'thirdPlatformXiaohongshuCampaignReport',
    'thirdPlatformXiaohongshuCreativeReport',
    'thirdPlatformQianchuan',
    'thirdPlatformQianchuanApp',
    'thirdPlatformQianchuanAuthorization',
    'thirdPlatformQianchuanAuthorizedAccount',
    'thirdPlatformQianchuanAccount',
    'thirdPlatformQianchuanAccountReport',
    'thirdPlatformQianchuanReportSummary',
    'thirdPlatformQianchuanMaterialReport',
    'thirdPlatformIeh5',
    'thirdPlatformIeh5Account',
    'thirdPlatformIeh5AdAccount',
    'thirdPlatformIeh5OrderManagement',
    'thirdPlatformIeh5IssuedData',
    'thirdPlatformIeh5MaterialAttribution',
    'thirdPlatformIeh5OperationReport',
    'thirdPlatformIeh5ShipinhaoReport',
    'thirdPlatformIeh5FinanceReport',
    'thirdPlatformIeh5PlacementData',
    'thirdPlatformIeh5MaterialReport',
    'thirdPlatformWechatNavigation',
    'systemWechatPublicAccounts',
    'systemWechatApps',
    'thirdPlatformWorkWxGroupWorkspace',
    'systemFeiShuApps',
  ],
  thirdPlatformTencentAd: [
    'thirdPlatformTencentAdAccess',
    'thirdPlatformTencentAdReports',
  ],
  thirdPlatformMapService: [
    'thirdPlatformMapSettings',
    'thirdPlatformMapTencent',
    'thirdPlatformMapAmap',
  ],
  thirdPlatformXingCheng: [
    'thirdPlatformXingChengTrafficOrder',
    'thirdPlatformXingChengAccount',
  ],
  thirdPlatformTangLang: [
    'thirdPlatformTangLangScheduledTask',
    'thirdPlatformTangLangAccount',
    'thirdPlatformTangLangProduct',
    'thirdPlatformTangLangTrafficOrder',
    'thirdPlatformTangLangCustomer',
    'thirdPlatformTangLangRefundOrder',
    'thirdPlatformTangLangPayOrder',
    'thirdPlatformTangLangCampLearning',
  ],
  thirdPlatformFeiShu: [
    'thirdPlatformFeiShuTrafficOrder',
    'thirdPlatformFeiShuSaleOrder',
    'thirdPlatformFeiShuBackendSaleOrder',
    'thirdPlatformFeiShuRpaOrder',
    'thirdPlatformFeiShuTableRecord',
    'systemFeiShuApps',
  ],
  thirdPlatformFeiShuNavigation: [
    'thirdPlatformFeiShuTrafficOrder',
    'thirdPlatformFeiShuSaleOrder',
    'thirdPlatformFeiShuBackendSaleOrder',
    'thirdPlatformFeiShuRpaOrder',
    'thirdPlatformFeiShuTableRecord',
    'systemFeiShuApps',
  ],
  thirdPlatformWorkWx: [
    'thirdPlatformWorkWxCorpWorkspace',
    'thirdPlatformWorkWxMemberWorkspace',
    'thirdPlatformWorkWxContactWorkspace',
    'thirdPlatformWorkWxFollowUser',
    'thirdPlatformWorkWxExternalPayBill',
    'thirdPlatformWorkWxExternalRefundOrder',
    'thirdPlatformWorkWxFundFlow',
    'thirdPlatformWorkWxGroupWorkspace',
  ],
  thirdPlatformWorkWxNavigation: [
    'thirdPlatformWorkWxCorpWorkspace',
    'thirdPlatformWorkWxMemberWorkspace',
    'thirdPlatformWorkWxContactWorkspace',
    'thirdPlatformWorkWxFollowUser',
    'thirdPlatformWorkWxExternalPayBill',
    'thirdPlatformWorkWxExternalRefundOrder',
    'thirdPlatformWorkWxFundFlow',
    'thirdPlatformWorkWxGroupWorkspace',
  ],
  thirdPlatformWechatPay: [
    'thirdPlatformWechatPayMerchant',
    'thirdPlatformWechatPayFundFlow',
    'thirdPlatformWechatPayTradeBill',
  ],
  thirdPlatformZhuGe: [
    'thirdPlatformZhuGeOrder',
    'thirdPlatformZhuGeAuthorReportDay',
    'thirdPlatformZhuGeAuthorVideoPlanDay',
    'thirdPlatformZhuGeReportDay',
  ],
  thirdPlatformWxShop: [
    'thirdPlatformWxShopFundsFlow',
    'thirdPlatformWxShopOrderFlow',
  ],
  thirdPlatformDouGong: ['thirdPlatformDouGongTradeBill'],
  thirdPlatformBank: ['thirdPlatformBankUnionPayFlow'],
  thirdPlatformBaidu: [
    'thirdPlatformBaiduApp',
    'thirdPlatformBaiduAuthorization',
    'thirdPlatformBaiduAccountReport',
    'thirdPlatformBaiduVideoReport',
  ],
  thirdPlatformXiaohongshu: [
    'thirdPlatformXiaohongshuApp',
    'thirdPlatformXiaohongshuAuthorization',
    'thirdPlatformXiaohongshuAccount',
    'thirdPlatformXiaohongshuNote',
    'thirdPlatformXiaohongshuAccountReport',
    'thirdPlatformXiaohongshuCampaignReport',
    'thirdPlatformXiaohongshuCreativeReport',
  ],
  thirdPlatformQianchuan: [
    'thirdPlatformQianchuanApp',
    'thirdPlatformQianchuanAuthorization',
    'thirdPlatformQianchuanAuthorizedAccount',
    'thirdPlatformQianchuanAccount',
    'thirdPlatformQianchuanAccountReport',
    'thirdPlatformQianchuanReportSummary',
    'thirdPlatformQianchuanMaterialReport',
  ],
  thirdPlatformIeh5: [
    'thirdPlatformIeh5Account',
    'thirdPlatformIeh5AdAccount',
    'thirdPlatformIeh5OrderManagement',
    'thirdPlatformIeh5IssuedData',
    'thirdPlatformIeh5MaterialAttribution',
    'thirdPlatformIeh5OperationReport',
    'thirdPlatformIeh5ShipinhaoReport',
    'thirdPlatformIeh5FinanceReport',
    'thirdPlatformIeh5PlacementData',
    'thirdPlatformIeh5MaterialReport',
  ],
  system: [
    'projectManagement',
    'projectList',
    'systemCourse',
    'systemCoursePeriod',
    'systemProduct',
    'systemChannel',
    'systemTeam',
    'systemDepartment',
    'systemRole',
    'systemPermission',
    'systemDataPermissionRoute',
    'systemEmployee',
    'systemDataProtection',
    'systemFeiShuTableConfigMapping',
    'material:list',
    'short-link:list',
    'systemMcp',
    'systemOperationLog',
  ],
  projectManagement: ['projectList'],
  systemTeam: [
    'systemDepartment',
    'systemRole',
    'systemPermission',
    'systemDataPermissionRoute',
  ],
  frontendSopTemplateCreate: ['frontendSopTemplateEdit'],
  thirdPlatformWechat: ['systemWechatPublicAccounts', 'systemWechatApps'],
  thirdPlatformWechatNavigation: [
    'systemWechatPublicAccounts',
    'systemWechatApps',
  ],
};
export const menuNames: Record<string, string> = {
  content: '内容管理',
  customPage: '微页面管理',
  customPageList: '微页面列表',
  'page:configure': '页面配置',
  'page:analytics': '页面统计',
  customForm: '表单管理',
  customFormList: '表单列表',
  'form:submissions': '提交明细',
  'form:submitters': '提交人',
  'form:report': '数据统计',
  common: '公共平台',
  commonUser: '用户管理',
  traffic: '流量平台',
  trafficLandingPage: '落地页配置',
  trafficConversionConfig: '小程序回传配置',
  trafficConversionLog: '小程序回传日志',
  trafficWorkWxContact: '企微加好友配置',
  trafficManagement: '流量管理',
  channelConversion: '渠道转化数据',
  channelRules: '渠道归因规则',
  trafficMaterialManagement: '素材管理',
  thirdPlatformBaiduAccountReport: '投放报表',
  thirdPlatformBaiduVideoReport: '百度视频报告',
  thirdPlatformXiaohongshuNote: '笔记列表',
  thirdPlatformQianchuanMaterialReport: '素材报表',
  thirdPlatformIeh5MaterialReport: '素材数据',
  trafficTrack: '例子管理',
  trafficMaterialTrace: '素材溯源',
  trafficDashboard: '投放看板',
  sale: '营销平台',
  saleClass: '班级管理',
  saleClassUser: '班级成员',
  saleOrder: '订单管理',
  dataOrderCenter: '订单中心',
  saleManualPayOrder: '补录订单',
  salePayOrder: '收款记录',
  saleSetting: '营销配置',
  saleCamp: '营期管理',
  frontend: '销售平台',
  frontendExperienceCamp: '1阶用户数据明细',
  frontendAutoOps: '自动化运营',
  frontendHostedWx: '托管微信号管理',
  frontendJuziAccount: '句子账号管理',
  frontendSopTemplate: '社群SOP模板',
  frontendTask: '任务管理',
  backend: '服务平台',
  meetingSales: '会销管理',
  meetingSalesActivity: '场次管理',
  meetingSalesHotel: '酒店管理',
  backendLevel2Users: '2阶用户数据明细',
  backendLevel3Users: '3阶用户数据明细',
  backendLevel4Users: '4阶用户数据明细',
  backendOrder: '订单管理',
  backendManualPayOrder: '补录订单',
  backendPayOrder: '收款记录',
  backendSetting: '后端配置',
  backendCamp: '场次管理',
  backendMember: '成员管理',
  backendMemberUser: '后端成员',
  bill: '财务中台',
  billSaleOrder: '营销订单',
  billSaleManualPayOrder: '营销补录订单',
  billSalePayOrder: '营销收款',
  billBackendOrder: '后端订单',
  billBackendManualPayOrder: '后端补录订单',
  billBackendPayOrder: '后端收款',
  billStatement: '账单',
  billBankStatement: '银行流水',
  billTangLangStatement: '螳螂流水',
  billStatementOrder: '全部订单',
  billLandingPageOrder: '落地页订单',
  billWorkWxOrder: '企微收款订单',
  data: '数据中台',
  dataCustomerManagement: '客户管理',
  dataCustomerList: '客户列表',
  dataCustomerField: '客户字段',
  dataCustomerTag: '客户标签',
  dataCustomerStage: '客户阶段',
  dataCustomerSource: '来源管理',
  dataCustomerChannel: '渠道管理',
  dataAutomationWorkflow: '自动化工作流',
  dataWorkflow: '工作流列表',
  dataTrack: '全链路用户数据',
  thirdPlatform: '第三方平台',
  thirdPlatformTencentAd: '腾讯广告',
  thirdPlatformTencentAdAccess: '接入管理',
  thirdPlatformTencentAdReports: '账户日报',
  thirdPlatformMapService: '地图服务',
  thirdPlatformMapSettings: '定位配置',
  thirdPlatformMapTencent: '腾讯地图',
  thirdPlatformMapAmap: '高德地图',
  thirdPlatformXingCheng: '星橙',
  thirdPlatformXingChengTrafficOrder: '例子订单',
  thirdPlatformXingChengAccount: '星橙账号',
  thirdPlatformTangLang: '螳螂',
  thirdPlatformTangLangScheduledTask: '定时任务',
  thirdPlatformTangLangAccount: '螳螂账号',
  thirdPlatformTangLangProduct: '商品列表',
  thirdPlatformTangLangTrafficOrder: '例子订单',
  thirdPlatformTangLangCustomer: '客户数据',
  thirdPlatformTangLangRefundOrder: '退款订单',
  thirdPlatformTangLangPayOrder: '支付订单',
  thirdPlatformTangLangCampLearning: '训练营',
  thirdPlatformFeiShu: '飞书',
  thirdPlatformFeiShuTrafficOrder: '例子订单',
  thirdPlatformFeiShuSaleOrder: '销售订单',
  thirdPlatformFeiShuBackendSaleOrder: '后端销售订单',
  thirdPlatformFeiShuRpaOrder: 'RPA订单',
  thirdPlatformFeiShuTableRecord: '飞书记录',
  thirdPlatformWorkWx: '企业微信',
  thirdPlatformWorkWxCorp: '企业',
  thirdPlatformWorkWxUser: '成员',
  thirdPlatformWorkWxExternalUser: '客户',
  thirdPlatformWorkWxFollowUser: '跟进关系',
  thirdPlatformWorkWxExternalPayBill: '对外收款账单',
  thirdPlatformWorkWxExternalRefundOrder: '企微退款订单',
  thirdPlatformWorkWxFundFlow: '资金流水',
  thirdPlatformWechatPay: '微信支付',
  thirdPlatformWechatPayMerchant: '商户账号',
  thirdPlatformWechatPayFundFlow: '资金流水',
  thirdPlatformWechatPayTradeBill: '交易账单',
  thirdPlatformZhuGe: '诸葛',
  thirdPlatformZhuGeOrder: '诸葛订单',
  thirdPlatformZhuGeAuthorReportDay: '作者日报',
  thirdPlatformZhuGeAuthorVideoPlanDay: '作者计划日报',
  thirdPlatformZhuGeReportDay: '投放日报',
  thirdPlatformWxShop: '微信小店',
  thirdPlatformWxShopFundsFlow: '资金流水',
  thirdPlatformWxShopOrderFlow: '订单流水',
  thirdPlatformDouGong: '斗拱平台',
  thirdPlatformDouGongTradeBill: '交易账单',
  thirdPlatformBank: '银行',
  thirdPlatformBankUnionPayFlow: '银联流水',
  thirdPlatformBaidu: '百度',
  thirdPlatformBaiduApp: '应用列表',
  thirdPlatformBaiduAuthorization: '授权账号',
  thirdPlatformXiaohongshu: '小红书',
  thirdPlatformXiaohongshuApp: '应用列表',
  thirdPlatformXiaohongshuAuthorization: '授权账号',
  thirdPlatformXiaohongshuAccount: '投放账号',
  thirdPlatformXiaohongshuAccountReport: '账户报表',
  thirdPlatformXiaohongshuCampaignReport: '计划报表',
  thirdPlatformXiaohongshuCreativeReport: '素材报表',
  thirdPlatformQianchuan: '巨量千川',
  thirdPlatformQianchuanApp: '应用列表',
  thirdPlatformQianchuanAuthorization: '授权账号',
  thirdPlatformQianchuanAuthorizedAccount: '授权主体',
  thirdPlatformQianchuanAccount: '投放账号',
  thirdPlatformQianchuanAccountReport: '报表明细',
  thirdPlatformQianchuanReportSummary: '报表汇总',
  thirdPlatformIeh5: '海豚',
  thirdPlatformIeh5Account: '账号配置',
  thirdPlatformIeh5AdAccount: '投放号',
  thirdPlatformIeh5OrderManagement: '订单管理',
  thirdPlatformIeh5IssuedData: '出单数据',
  thirdPlatformIeh5MaterialAttribution: '素材溯源结果',
  thirdPlatformIeh5OperationReport: '运营报表-视频',
  thirdPlatformIeh5ShipinhaoReport: '运营报表-投放号',
  thirdPlatformIeh5FinanceReport: '财务报表',
  thirdPlatformIeh5PlacementData: '投放数据',
  system: '系统设置',
  projectManagement: '项目管理',
  projectList: '项目列表',
  systemCourse: '训练营管理',
  systemCoursePeriod: '营期管理',
  systemProduct: '商品管理',
  systemChannel: '渠道管理',
  systemTeam: '团队管理',
  systemDepartment: '成员管理',
  systemRole: '角色管理',
  systemPermission: '权限管理',
  systemDataPermissionRoute: '数据权限管理',
  systemEmployee: '员工管理',
  systemDataProtection: '数据保护',
  systemFeiShuTableConfigMapping: '飞书表格映射',
  materialLibrary: '素材库',
  systemWechatPublicAccounts: '微信公众号',
  systemWechatApps: '微信小程序',
  systemWorkWxApps: '查看与同步',
  systemFeiShuApps: '应用管理',
  shortLink: '短链管理',
  systemMcp: 'MCP 管理',
  systemOperationLog: '操作日志',
  systemDataPermission: '数据规则',
  dataCustomerBehavior: '客户画像行为',
  trafficAccountBinding: '投放账号项目绑定',
  thirdPlatformBankStatement: '银行流水导入',
  meetingSalesRoom: '房型管理',
  meetingSalesRegistration: '报名与签到',
  meetingSalesBooking: '酒店预约',
  meetingSalesRooming: '拼房管理',
  meetingSalesGroup: '分组管理',
  meetingSalesMembers: '分组成员',
  meetingSalesActivityDetail: '场次详情',
  meetingSalesHotelDetail: '酒店详情',
  thirdPlatformMapServiceEdit: '编辑定位配置',
  thirdPlatformMapServiceLocate: '定位测试',
  thirdPlatformMapServiceLog: '调用日志',
  frontendHostedWxZhonghui: '托管微信号管理（中荟）',
  frontendSopTemplateCreate: '新建',
  frontendSopTemplateEdit: '编辑',
  frontendTaskCreate: '新建',
  frontendTaskList: '查看列表与详情',
  'form:list': '查看表单',
  thirdPlatformWechat: '微信',
  thirdPlatformWorkWxGroupChat: '客户群',
};
